import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    window.onscroll = function () {
      const btn = document.getElementById("scrollTop");

      if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
        btn.style.display = "block";
      } else {
        btn.style.display = "none";
      }
    };
  }

  scroll() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
}
